import { formatDate } from '../formatDate';

import { isDateValid } from './isDateValid';
import { isEmpty } from './isEmpty';

const invalidDateMessage = 'Некорректная дата';

export const validateDate = (
  date: string | undefined,
  minDate?: Date,
  maxDate?: Date,
): string | undefined => {
  if (isEmpty(date)) return invalidDateMessage;

  if (!isDateValid(date!)) return invalidDateMessage;

  const d = new Date(date!);

  if (minDate && d < minDate) return `Не ранее ${formatDate(minDate)}`;

  if (maxDate && d > maxDate) return `Не позднее ${formatDate(maxDate)}`;
};
